import { useCallback } from 'react';

import { MessageBarType } from '@fluentui/react/lib/MessageBar';

export function useFloatingBannerMessage(dispatch) {
  const showError = useCallback((msg) => {
    dispatch({
      type: 'SET_FLOATING_BANNER',
      payload: {
        isShow: true,
        msgInfo: msg,
        msgType: MessageBarType.error,
      },
    });
  }, [dispatch]);

  const showInfo = useCallback((msg) => {
    dispatch({
      type: 'SET_FLOATING_BANNER',
      payload: {
        isShow: true,
        msgInfo: msg,
        msgType: MessageBarType.success,
      },
    });
  }, [dispatch]);

  const showWarning = useCallback((msg) => {
    dispatch({
      type: 'SET_FLOATING_BANNER',
      payload: {
        isShow: true,
        msgInfo: msg,
        msgType: MessageBarType.warning,
      },
    });
  }, [dispatch]);

  const hideFloatingBanner = useCallback(() => {
    dispatch({
      type: 'SET_FLOATING_BANNER',
      payload: {
        isShow: false,
        msgInfo: '',
        msgType: MessageBarType.warning,
      },
    });
  }, [dispatch]);

  return {
    showError,
    showInfo,
    showWarning,
    hideFloatingBanner,
  };
}
